const translations = {
    'biome.coast': 'coast',
    'biome.forest': 'forest',
    'biome.hills': 'hills',
    'biome.mountains': 'mountains',
    'biome.plains': 'plains',
    'biome.water': 'water',
    'biome.wetlands': 'wetlands',
};

export default translations;
